import React from "react";
import {
  FollowSignalData,
  OneClickFollowBotData,
  QueryStatus,
  SubGroup,
  SymbolClientsData,
} from "@shared/types";
import { FollowSignalType } from "@shared/features/signals/common/types";

export const FollowSignalsContext = React.createContext<
  | {
      openFollowModal: (
        signal: FollowSignalData,
        followSignalType: FollowSignalType
      ) => void;
      getClientsDataFromSymbolStatus: QueryStatus<SymbolClientsData[]>;
      groupData: SubGroup | undefined;
      getExchangeSignalIdsStatus: QueryStatus<Record<string, number>>;
      getBotsOneClickDataStatus: QueryStatus<OneClickFollowBotData[]>;
      isFetching?: boolean;
      isLoading?: boolean;
      getItemErrorMessage: (
        account?: SymbolClientsData,
        bot?: OneClickFollowBotData
      ) => string | undefined;
      signal: FollowSignalData | undefined;
      followType: FollowSignalType | undefined;
      getBotAccountData: (
        bot?: OneClickFollowBotData
      ) => SymbolClientsData | undefined;
    }
  | undefined
>(undefined);
